import React, { useContext, useState, useEffect } from "react";
// import MainLayout from "../../common/layout/MainLayout";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
// import SearchIcon from "@mui/icons-material/Search";
import FilterModal from "./component/modal/FilterModal";
import { StoreContext } from "../../store";
// import FieldSelect from "../../common/component/form/FieldSelect";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
} from "@mui/material";
// import TableScrollDiv from "./../../common/component/table/TableScrollDiv";
import "./index.css";
import instance from "../../common/api/interceptor";
import { path } from "../../constants/apiPath";
import Loading from "../loading/Loading";
import moment from "moment";
import { NotificationManager } from "react-notifications";
import InfiniteScroll from "react-infinite-scroller";
import exportFromJSON from "export-from-json";
// import Paper from "@material-ui/core/Paper";
import { useLocation, useNavigate } from "react-router-dom";
import routeConstant from "../../../route/compoent/routeConstant";

function SystemLog() {
  const context = useContext(StoreContext);
  const [loading, setLoading] = useState(false);
  const [orderBy, setOrderBy] = useState("Log_LastUpdatedDate");
  const [order, setOrder] = useState("desc");
  // const [logData, setLogData] = useState([]);
  // const [isMount, setIsMount] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const column = [
    {
      id: "SrNo",
      label: "Sr. No",
    },
    {
      id: "Log_OrderNumber",
      label: "Order ID",
    },
    {
      id: "Log_Activity",
      label: "Activity",
    },
    {
      id: "Log_LastUpdatedDate",
      label: "Date",
    },
    {
      id: "Log_UserCreateOrEdited",
      label: "Done By",
    },
    {
      id: "Log_Orgnisations",
      label: "Organisation",
    },
  ];
  const [pageNumber, setPageNumber] = useState(0);
  const [hasMore, setHasMore] = useState(false);
  const pageSize = 20;

  useEffect(() => {
    context.setLogData([]);
    if (location.state && location.state.OrderPK) {
      getSystemLogg(
        location.state.OrderPK,
        "",
        "",
        "",
        "",
        "",
        "",
        orderBy,
        order
      );
    } else {
      if (
        location.pathname.includes(routeConstant.DASH_ORDER_LIST_FULL_LOG) ||
        location.pathname.includes(routeConstant.ORDER_LIST_FULL_LOG)
      ) {
        navigate(routeConstant.SYSTEM_LOG);
      } else {
        getSystemLogg("", "", "", "", "", "", "", orderBy, order);
      }
    }
  }, [location]);

  const onLoadMore = () => {
    const count = pageNumber + 1;
    getSystemLogg(
      location?.state?.OrderPK ?? "",
      "",
      "",
      "",
      "",
      "",
      "",
      orderBy,
      order,
      count
    );
  };

  const getSystemLogg = async (
    OrderPK = "",
    FromDate = "",
    ToDate = "",
    OrderID = "",
    Ativity = "",
    Doneby = "",
    Orgnisation = "",
    orderBy = orderBy,
    order = order,
    CurrentPage = pageNumber
  ) => {
    if (CurrentPage === 0) {
      setLoading(true);
    }
    setHasMore(false);
    const body = {
      OrderPK,
      FromDate,
      ToDate,
      OrderID,
      Ativity,
      Doneby,
      Orgnisation,
      SplitNumber: "",
      SortColumnName: orderBy,
      SortDirection: order,
      CurrentPage: CurrentPage,
      PageSize: pageSize,
    };
    await instance
      .post(path.GET_LOG, body)
      .then((res) => {
        setPageNumber(CurrentPage);
        if (res.Is_Success) {
          context.setLogData((prev) => [...prev, ...(res.data ?? [])]);
        } else {
          NotificationManager.error(res.Message, "", 3000);
        }
        let hasMorecheck = res.data?.length === pageSize ? true : false;
        setHasMore(hasMorecheck);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        if (err.response) {
          NotificationManager.error(err.response.data.Message, "", 3000);
        } else if (err.request) {
        } else if (err.message) {
        } else {
          NotificationManager.error("Something went wrong!", "", 3000);
        }
        setLoading(false);
      });
  };

  const onDownload = () => {
    context.setBackDropOpen(true);
    let body = {};
    let apiPath = `${path.USER_LOGG_Download}`;
    if (location.state && location.state.OrderPK) {
      apiPath = path.GET_LOG;
      body = {
        OrderPK: location.state.OrderPK,
        FromDate: "",
        ToDate: "",
        OrderID: "",
        Ativity: "",
        Doneby: "",
        Orgnisation: "",
        SplitNumber: "",
        SortColumnName: orderBy,
        SortDirection: order,
        CurrentPage: 0,
        PageSize: 0,
      };
    }
    instance
      .post(apiPath, body)
      .then(async (res) => {
        if (res.Is_Success) {
          const data = res.data;
          const fileName = "User Logg";
          const exportType = exportFromJSON.types.xls;
          await exportFromJSON({ data, fileName, exportType });
          context.setBackDropOpen(false);
        } else {
          NotificationManager.error(res.Message, "", 3000);
          context.setBackDropOpen(false);
        }
      })
      .catch((err) => {
        console.error(err);
        if (err.response) {
          NotificationManager.error(err.response.data.Message, "", 3000);
        } else if (err.request) {
        } else if (err.message) {
        } else {
          NotificationManager.error("Something went wrong!", "", 3000);
        }
        context.setBackDropOpen(false);
      });
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
    context.setLogData([]);
    setPageNumber(0);
    getSystemLogg(
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      property,
      isAsc ? "desc" : "asc",
      0
    );
  };

  const EnhancedTableHead = ({ column, order, orderBy, onRequestSort }) => {
    const createSortHandler = (property) => (event) => {
      onRequestSort(event, property);
    };

    return (
      <TableHead>
        <TableRow>
          {column.map((ele, index) => {
            if (index === 0) {
              return <TableCell key={ele.id}>Sr. No</TableCell>;
            } else {
              return (
                <TableCell
                  key={ele.id}
                  sortDirection={orderBy === ele.id ? order : false}
                >
                  <TableSortLabel
                    active={orderBy === ele.id}
                    direction={orderBy === ele.id ? order : "asc"}
                    onClick={createSortHandler(ele.id)}
                  >
                    {ele.label}
                  </TableSortLabel>
                </TableCell>
              );
            }
          })}
        </TableRow>
      </TableHead>
    );
  };

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <div className="_systemLog">
          <div className="_sytemSortDialog">
            {location.state && location.state.OrderPK ? null : (
              <div
                className="_systemLogFilter"
                onClick={() => context.setModalOpen(true)}
              >
                <FilterAltOutlinedIcon />
              </div>
            )}
            <div className="_outlineButton">
              <button onClick={onDownload}>Download Log</button>
            </div>
          </div>
          <div className={`_tableScroll _systemLogTable`}>
            <TableContainer
              // component={Paper}
              className="_tableScrollTableContainer"
            >
              <InfiniteScroll
                className="infiniteScroller"
                pageStart={0}
                loadMore={onLoadMore}
                hasMore={hasMore}
                loader={
                  <div className="_scrollLoader">
                    <Loading />
                  </div>
                }
                useWindow={false}
              >
                <Table stickyHeader id="downloadTable">
                  <EnhancedTableHead
                    column={column}
                    order={order}
                    orderBy={orderBy}
                    onRequestSort={handleRequestSort}
                  />
                  <TableBody>
                    {loading ? (
                      <TableRow>
                        <TableCell colSpan={7}>
                          <Loading />
                        </TableCell>
                      </TableRow>
                    ) : context.logData.length === 0 ? (
                      <TableRow>
                        <TableCell colSpan={7}>No logg found!</TableCell>
                      </TableRow>
                    ) : (
                      context.logData.map((ele, index) => {
                        return (
                          <TableRow key={index}>
                            <TableCell>{index + 1}</TableCell>
                            <TableCell>{ele.OrderID}</TableCell>
                            <TableCell>{ele.Ativity}</TableCell>
                            <TableCell>
                              {ele.Date
                                ? moment(ele.Date).format(
                                    "MM-DD-YYYY hh:mm:ss A"
                                  )
                                : ""}
                            </TableCell>
                            <TableCell>{ele.Doneby}</TableCell>
                            <TableCell>{ele.Orgnisation}</TableCell>
                          </TableRow>
                        );
                      })
                    )}
                  </TableBody>
                </Table>
              </InfiniteScroll>
            </TableContainer>
          </div>
        </div>
      )}

      <FilterModal setLoading={setLoading} getSystemLogg={getSystemLogg} />
    </>
  );
}

export default SystemLog;
